import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getSingleDataFromDatabase } from "../utils/api";
import { toast } from "react-toastify";

const ReportNavBar = () => {
    const navigate = useNavigate();
    const ppcid = localStorage.getItem("ppcdata");
    const [ppc, setPPC] = useState({});
    const [currentTime, setCurrentTime] = useState(new Date());

    // 1) Always-running clock
    useEffect(() => {
        const t = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(t);
    }, []);

    // 2) Load PPC or redirect
    useEffect(() => {
        if (!ppcid) {
            navigate("/");
            return;
        }
        (async () => {
            try {
                const res = await getSingleDataFromDatabase(`ppc-get-single-data/${ppcid}`);
                if (res?.data?.status === 1) setPPC(res.data.ppcdata || {});
                else toast.error(res?.data?.message || "Failed to load PPC data");
            } catch (e) {
                console.error(e);
                toast.error("Network/CORS error while loading PPC data");
            }
        })();
    }, [ppcid, navigate]);

    const formattedTime = currentTime.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });

    const greeting = () => {
        const h = currentTime.getHours();
        if (h < 12) return "Good Morning";
        if (h < 17) return "Good Afternoon";
        return "Good Evening";
    };

    const canSeeReports = Number(ppc?.ppc_report) === 1;
    const canSeeTeams = Number(ppc?.ppc_team) === 1;

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h4 className="dashboardname m-0">
                    {greeting()}, <span>{ppc?.ppc_name || ""}</span>
                </h4>
                <h4 className="m-0" style={{ fontWeight: 600 }}>
                    ⏰ {formattedTime}
                </h4>
            </div>

            <div className="page-wrapper mb-1">
                <div className="reportdiv">
                    <ul className="reportlink">
                        <li className="btnreport">
                            <NavLink to="/dashboard" end>
                                <span>T’day Calls</span>
                            </NavLink>
                        </li>
                        <li className="btnreport">
                            <NavLink to="/yesterday-call-report">
                                <span>Y’day Calls</span>
                            </NavLink>
                        </li>
                        <li className="btnreport">
                            <NavLink to="/last-week-call-report">
                                <span>Last 7d Calls</span>
                            </NavLink>
                        </li>
                        <li className="btnreport">
                            <NavLink to="/day-wise-report">
                                <span>Day Wise</span>
                            </NavLink>
                        </li>

                        {canSeeReports && (
                            <>
                                <li className="btnreport">
                                    <NavLink to="/center-performance-report">
                                        <span>Center Performance</span>
                                    </NavLink>
                                </li>
                                <li className="btnreport">
                                    <NavLink to="/agent-performance-report">
                                        <span>Agent Performance</span>
                                    </NavLink>
                                </li>
                            </>
                        )}

                        {canSeeTeams && (
                            <li className="btnreport">
                                <NavLink to="/today-team-report">
                                    <span>T’day Team Calls</span>
                                </NavLink>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ReportNavBar;
